export function isOwner (ref, id) {
    return ref.where('ownerUid', '==', id)
}